import { useHttpClient } from '@/common/api/httpClient';
import { storeToRefs } from 'pinia';
import { useLanguageStore } from 'shared/translations/stores/languageStore';

export interface SiteListResponse {
  sites: SiteResponse[];
}

export function useListSites() {
  const httpClient = useHttpClient();
  const languageStore = useLanguageStore();
  const { translations } = storeToRefs(languageStore);

  return {
    execute,
  };

  async function execute() {
    const headers = httpClient.defaultHeaders();
    const request = new Request('api/site', {
      headers: headers,
      method: 'GET',
    });

    const text = translations.value.sites.actions.fetchMany;

    return await httpClient.action(request, {
      title: text.title,
      errorTitle: text.error,
      async processOk(response) {
        const json = (await response.json()) as SiteListResponse;
        return {
          ok: true,
          sites: json.sites,
        };
      },
    });
  }
}

export interface SiteResponse {
  id: number;
  name: string;
}
